export default __webpack_public_path__ + "static/media/rewind.6a0fa3e9.svg";